import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import SelectIntegrationDialog from './dialog';

import useAccountPermission from '../../../../hooks/useAccountPermission';

import { isRewardoAdmin } from '../../../../helpers/authorization';

import {
  currentAccountState,
  currentIntegrationIdState,
  integrationsState,
} from '../../../../store';

function SelectIntegrationContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentAccount = useAtomValue(currentAccountState);
  const currentIntegrationId = useAtomValue(currentIntegrationIdState);
  const integrations = useAtomValue(integrationsState);

  const hasAtLeastOneIntegration =
    !isRewardoAdmin(currentAccount) && Boolean(integrations && integrations.length >= 1);

  const mustDisplayDialog = hasAtLeastOneIntegration && currentIntegrationId === undefined;

  const close = useCallback(() => {
    navigate(
      {
        ...location,
        hash: '',
      },
      { state: location.state },
    );
  }, [location, navigate]);

  return (
    <SelectIntegrationDialog
      mustDisplayDialog={mustDisplayDialog}
      onDismiss={mustDisplayDialog ? undefined : close}
    />
  );
}

export default function SelectIntegration() {
  const shouldDisplayIntegrations = useAccountPermission('integrations_view');

  if (!shouldDisplayIntegrations) {
    return null;
  }

  return <SelectIntegrationContent />;
}
